// extracted by mini-css-extract-plugin
export default {"detailHeader":"PhotoDetail_detailHeader__c2l5t","detailText":"PhotoDetail_detailText__PTJN+"};